



































































































import {Component, Watch} from "vue-property-decorator";
import FieldData from "@/components/infrastructures/functions/fieldData";
import httpResource from "@/components/infrastructures/functions/http/httpResource";
import {AuthActionTypes} from "@/store/auth/types";
import router from "@/router";
import {Step} from "@/components/infrastructures/molecules/StepContents.vue";
import GeneralField from "@/components/infrastructures/atoms/GeneralField.vue";
import AgreementsStore from "@/components/domains/account/register/general/agreementsStore";
import {PurchaseMutationTypes} from "@/store/product/purchase/types";
import InnerScrollCard from "@/components/infrastructures/atoms/designed/InnerScrollCard.vue";
import TermsOfServiceText from "@/components/domains/agreement/TermsOfServiceText.vue";
import ProvidingDataAgreementText from "@/components/domains/agreement/ProvidingDataAgreementText.vue";
import {signupMode} from "@/components/domains/account/passwordless/authPolicy";
import PasswordlessService, {
  errorMessage,
  errorReason,
  FALLBACK_ERROR,
  loadAuthPolicy
} from "@/components/domains/account/passwordless/passwordlessService";

const USERNAME_PATTERN = /^[a-zA-Z0-9_-]+$/;

@Component({
  components: {GeneralField, InnerScrollCard, TermsOfServiceText, ProvidingDataAgreementText}
})
export default class PersonalRegisterForm extends Step {

  name = "PersonalRegisterForm";
  email = "";

  // TODO default: false <- 同意済み
  approval = true;

  // error
  errorMessage = "";
  hasError = false;

  dialog = false;

  // パスワードなしの登録
  policyLoaded = false;
  passwordless = false;
  passwordlessUsername = "";
  agreeTermsOfService = false;
  agreeProvidingData = false;
  showTerms = false;
  showProvidingData = false;
  registering = false;
  passwordlessError = "";
  passwordlessErrorAction: "" | "login" | "restart" = "";

  private usernameField: FieldData = new FieldData()
      .withId("username")
      .withRequires(true)
      .withType("text_field")
      .withLabel("ユーザー名 (半角英数字)");

  private loginIdField: FieldData = new FieldData()
      .withId("loginId")
      .withRequires(true)
      .withType("text_field")
      .withLabel("メールアドレス");

  private passwordField: FieldData = new FieldData()
      .withId("password")
      .withRequires(true)
      .withType("password")
      .withLabel("パスワード (8文字以上)");

  private verifyPasswordField: FieldData = new FieldData()
      .withId("verify_password")
      .withRequires(true)
      .withType("password")
      .withLabel("確認用パスワード");

  private registerBtnField: FieldData = new FieldData()
      .withId("registerBtn")
      .withType("button")
      .withLabel('登録')
      .withClickAction(this.register);

  private resetBtnField: FieldData = new FieldData()
      .withId("resetBtn")
      .withType("back_button")
      .withLabel('リセット')
      .withClickAction(this.reset);

  getStepTitle(): string {
    return "ユーザー情報の登録";
  }

  public getComponentName(): string {
    return this.name;
  }

  beforeMount() {

    const path = this.$route.params.path;
    this.hasError = false;

    loadAuthPolicy({fresh: true}).then((policy) => {
      this.passwordless = signupMode(policy) === "passwordless";
      this.policyLoaded = true;
    });

    httpResource.post(`/account/confirm-temp-url?path=${path}`)
        .then((response: any) => {
          this.email = response.data;
          this.loginIdField.value = this.email;
        })
        .catch((error: any) => {
          this.errorMessage = error.response.data.message;
          this.hasError = true;
        })
  }

  @Watch('passwordField.value')
  private u1() {
    this.validatePassword();
  }

  @Watch('verifyPasswordField.value')
  private u2() {
    this.validatePassword();
  }

  validatePassword() {
    const password = this.passwordField.value.trim();
    const verifyPassword = this.verifyPasswordField.value.trim();
    this.passwordField.resetError();
    this.verifyPasswordField.resetError();
    if (password !== '' && verifyPassword !== '' && password !== verifyPassword) {
      this.passwordField.error = true;
      this.passwordField.errorMessage = 'パスワードが一致しません';
      this.verifyPasswordField.error = true;
      this.verifyPasswordField.errorMessage = 'パスワードが一致しません';
    }
  }

  register() {

    this.resetFormErrors();

    const data = {
      email: this.loginIdField.value,
      username: this.usernameField.value,
      password: this.passwordField.value,
      verifyPassword: this.verifyPasswordField.value,
      agreeTermsOfService: AgreementsStore.agreeTermsOfService,
      agreeProvidingData: AgreementsStore.agreeProvidingData
    };

    httpResource.post('/account/register/general', data)
        .then((response: any) => {
          const loginId = this.usernameField.value;
          const password = this.passwordField.value;
          this.$store.dispatch(AuthActionTypes.login, {"loginId": loginId, "password": password})
              .then(() => {
                if (response.data.productId) {
                  this.$store.commit(PurchaseMutationTypes.setProductId, response.data.productId);
                  alert("アカウントの作成が完了しましたので、選択したプランの決済ページに遷移します。");
                  router.push("/payment");
                } else {
                  router.push("/mypage");
                }
              });
        })
        .catch((error: any) => {
          alert(error.response.data.message);
        });
  }

  /** パスワードなしの登録（/account/register/passwordless）。成功すると Set-Cookie でそのままログイン状態になる。 */
  async registerPasswordless() {
    if (this.registering) {
      return;
    }
    this.passwordlessError = "";
    this.passwordlessErrorAction = "";

    const username = this.passwordlessUsername.trim();
    if (username === "" || username.length > 100 || !USERNAME_PATTERN.test(username)) {
      this.passwordlessError = "ユーザー名は半角英数字と - _ で、100文字以内にしてください。";
      return;
    }
    if (!this.agreeTermsOfService || !this.agreeProvidingData) {
      this.passwordlessError = "利用規約と調査結果の取り扱いの両方に同意してください。";
      return;
    }

    this.registering = true;
    let response: any;
    try {
      response = await PasswordlessService.registerPasswordless({
        path: this.$route.params.path,
        username,
        host: null,
        agreeTermsOfService: this.agreeTermsOfService === true,
        agreeProvidingData: this.agreeProvidingData === true,
      });
    } catch (error) {
      this.registering = false;
      const reason = errorReason(error);
      this.passwordlessError = errorMessage(error, FALLBACK_ERROR);
      if (reason === "SIGNUP_ALREADY_REGISTERED") {
        this.passwordlessErrorAction = "login";
      } else if (reason === "SIGNUP_LINK_INVALID" || reason === "SIGNUP_LINK_USED" || reason === "SIGNUP_LINK_EXPIRED") {
        this.passwordlessErrorAction = "restart";
      }
      return;
    }

    // 通常のログインと同じ後処理（/auth/me → store → 更新タイマー）。
    await this.$store.dispatch(AuthActionTypes.authenticateUser);
    const productId = response && response.data ? response.data.productId : null;
    if (productId) {
      // これまでと同じく、選択していたプランの決済ページへ。
      this.$store.commit(PurchaseMutationTypes.setProductId, productId);
      router.push("/payment");
    } else {
      router.push("/mypage");
    }
  }

  reset() {
    this.resetFormErrors();
    this.usernameField.withValue('');
    this.passwordField.withValue('');
    this.verifyPasswordField.withValue('');
  }

  resetFormErrors() {
    this.resetErrors();
    this.loginIdField.withError(false);
    this.loginIdField.withErrorMessage('');
    this.passwordField.withError(false);
    this.passwordField.withErrorMessage('');
  }

  resetErrors() {
    this.hasError = false;
  }
}
